import { api } from './api-client';
import type {
  GetAggregationByProperty,
  GetFunnels,
  GetJourneys,
  GetRetention,
  FunnelResult,
  JourneyResult,
  AggregationData,
  RetentionData,
} from '@/types';

export const AnalyticsService = {
  getFunnels: async ({ projectId, startDate, endDate, steps }: GetFunnels) => {
    const { data } = await api.post<{ data: FunnelResult }>(
      `/analytics/v2/funnels`,
      {
        projectId,
        startDate,
        endDate,
        steps,
      },
    );
    return data;
  },

  getAggregationByProperty: async ({
    projectId,
    eventName,
    metadataField,
    field,
    sumMetadataField,
    startDate,
    endDate,
    filterGroups,
  }: GetAggregationByProperty) => {
    const { data } = await api.post<{ data: AggregationData }>(
      `/analytics/aggregate-by-property`,
      {
        projectId,
        eventName,
        metadataField,
        field,
        sumMetadataField,
        startDate,
        endDate,
        filterGroups,
      },
    );
    return data;
  },

  getRetention: async ({
    projectId,
    startDate,
    endDate,
    filterGroups,
  }: GetRetention) => {
    const { data } = await api.post<{ data: RetentionData }>(
      `/analytics/retention`,
      {
        projectId,
        startDate,
        endDate,
        filterGroups,
      },
    );
    return data;
  },

  getJourneys: async ({
    projectId,
    anchor,
    depth,
    direction,
    startDate,
    endDate,
    filterGroups,
    excludeEvents,
    topK,
    minCount,
  }: GetJourneys) => {
    const { data } = await api.post<{ data: JourneyResult }>(
      `/analytics/journeys`,
      {
        projectId,
        anchor,
        depth,
        direction,
        startDate,
        endDate,
        filterGroups,
        excludeEvents,
        topK,
        minCount,
      },
    );
    return data;
  },
};
